module.exports = __webpack_public_path__ + "static/media/webscrap-min.dfff8d2b.png";